export default __webpack_public_path__ + "static/media/ringle.0d31bbe1.png";